<template>
  <div class="col-12">
    <questionCard
      class="p-0"
      :openNewTab="true"
      :title="$lang.azmoonLang.question_exam_pack"
      :url="exam_pack_question_url"
      :show_checkbox="false"
      :show_add="false"
      @changeValue="changeValue"
      ref="exam_pack_question"
      @edit_item="userEditor"
      :outParams="`&order_by:question_order:asc`"
      :editBtnTooltip="$lang.azmoonLang.exam_pack_edit_question"
      :dynamicButtons="dynamicButtons"
      :isDynamicButtons="true"
      @getOtherData="getOtherData"
    >
      <template slot="headerButtons">
        <b-button
          @click="toggleModal"
          v-b-tooltip.hover
          :title="$lang.azmoonLang.search.add_tooltip"
          class="btn btn-lightgray ml-2 btn-secondary"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </b-button>
      </template>
      <template slot="addBtnQuestion" slot-scope="{ item }">
        <div
          @click="editExamPackQuestion(item)"
          v-b-tooltip.hover
          :title="$lang.azmoonLang.edit_exam_pack_question_question"
        >
          <i class="fas fa-external-link-alt fa-lg text-info"></i>
        </div>
      </template>
    </questionCard>

    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="modal"
      size="xl"
      ok-only
      hide-header
    >
      <questionCard
        :title="$lang.azmoonLang.question_list"
        :url="question_url"
        :showBtn="false"
        :show_checkbox="true"
        :show_add="false"
        @changeValue="changeValue"
        :questionSelected="questions"
        :outParams="`&exclude_exam_pack[]=${id}`"
      />
      <template v-slot:modal-footer>
        <b-button class="mr-2" variant="outline-danger" @click="modal = false">
          <mdicon name="close" size="20" />
          {{ $lang.azmoonLang.cancelButton }}
        </b-button>
        <b-button variant="success" @click="putAzmoon">
          <mdicon name="check" size="20" />

          {{ $lang.azmoonLang.submitButton }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="modalQuestion"
      size="xl"
      ok-only
      hide-header
      hide-footer
    >
      <editExamPackQuestion
        @getData="getData"
        :item="optionItem"
        :exam_pack_id="id"
        :random_display_questions="
          pathOr(false, ['exam_pack', 'random_display_questions'], otherData)
        "
        @cancel="closeModal"
      />
    </b-modal>
  </div>
</template>

<script>
import questionCard from "@/components/azmoon/question/questionCard";
import editExamPackQuestion from "./editExamPackQuestion";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "search_exam_pack_question",
  components: {
    questionCard,
    editExamPackQuestion,
  },
  inject: ["examPackQuestionRepository"],
  data() {
    return {
      dynamicButtons: [
        {
          id: "2",
          name: "edit", // ویرایش
          iconFont: "fa fa-edit fa-lg  text-success ",
          text: this.editBtnTooltip
            ? this.editBtnTooltip
            : this.$lang.search.edit_tooltip,
          AllowPermissions: ["admin", "edit"],
        },
        {
          id: "3",
          name: "delete", //حذف
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times  fa-lg text-danger ",
          AllowPermissions: ["admin"],
        },

        {
          id: "4",
          name: "view", //نمایش
          text: this.$lang.show,
          iconFont: "fa fa-eye  fa-lg  text-success",
          AllowPermissions: ["view"],
        },
      ],
      modal: false,
      modalQuestion: false,
      id: this.$route.params.id,
      exam_pack_question_url:
        this.$config.api_url +
        this.$config.azmoon.exam_pack_question.replace(
          "{0}",
          this.$route.params.id
        ),
      questions: [],
      optionItem: [],
      itemsShowKind: [],
      optionItemTitle: null,

      permissionButtons: ["admin"],
      otherData: null,
    };
  },
  computed: {
    question_url() {
      return generateApiUrl(["azmoon", "exam_pack_all_question"], [this.id]);
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    countItems(item) {
      this.$emit("countItems", item);
    },
    userEditor(item) {
      let routeData = this.$router.resolve({
        name: "edit_structureQuestion",
        params: {
          id: item.question_info.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    editExamPackQuestion(item) {
      this.modalQuestion = true;
      this.optionItem = item;
    },
    changeValue(item) {
      let object = this.questions.find((x) => x.id == item.id);
      if (object == undefined) {
        this.questions.push(item);
      } else {
        let index = this.questions.indexOf(item);
        this.questions.splice(index, 1);
      }
    },
    closeModal() {
      this.modalQuestion = false;
    },
    getData() {
      this.modalQuestion = false;
      this.$refs.exam_pack_question.getItems();
    },
    // async patchExamPackAzmoon() {
    //   try {
    //     let payload = {};
    //     let group = {
    //       key: "exam_pack_id",
    //       value: this.id,
    //     };
    //     payload = {
    //       field_name: "question_order",
    //       start_order: this.optionItem.question_order,
    //       end_order: this.order,
    //       group,
    //     };
    //     let order_url =
    //       this.$config.api_url + this.$config.azmoon.exam_pack_questions_order;
    //     const response = await this.$httpService.patch(order_url, payload);
    //     this.$notify.success(response.data.message);
    //     this.$refs.exam_pack_question.getItems();
    //     this.modalQuestion = false;
    // } catch (error) {
    //   this.$generateError(error);
    //   }
    // },
    removeExamPackQuestion(item) {
      let url = this.exam_pack_question_url + `/${item.question.id}`;
      return this.$httpService
        .delete(url)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          return false;
        })
        .finally(() => {
          this.$refs.exam_pack_question.getItems();
        });
    },
    toggleModal() {
      let itemsId = this.$refs.exam_pack_question.items.map((x) => {
        return {
          id: x.question_info ? x.question_info.id : null,
        };
      });
      this.modal = !this.modal;
      this.questions = itemsId;
    },
    async putAzmoon() {
      try {
        let payload = {
          questions: this.questions.map((x) => x.id),
        };
        const response = await this.examPackQuestionRepository.edit(
          this.id,
          payload
        );
        this.$notify.success(response.data.message);
        this.toggleModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$refs.exam_pack_question.getItems();
      }
    },
    getOtherData(data) {
      this.otherData = data;
    },
  },
};
</script>
